module.exports = __webpack_public_path__ + "static/media/institute-5-min.63f62e93.webp";